import { defineComponent as n, computed as r, createBlock as i, openBlock as t, resolveDynamicComponent as d, normalizeClass as c, withCtx as p, renderSlot as f, createElementBlock as a, createCommentVNode as u, toDisplayString as m, unref as w } from "vue";
import { t as b } from "./locale.js";
const h = {
  key: 0,
  class: "tw-font-semibold tw-text-red-500",
  title: "Required",
  "aria-label": "required"
}, _ = {
  key: 1,
  class: "tw-text-ice-700"
}, x = /* @__PURE__ */ n({
  __name: "Label",
  props: {
    for: { default: void 0 },
    hasError: { type: Boolean, default: !1 },
    isRequired: { type: Boolean, default: !1 },
    showOptional: { type: Boolean, default: !1 },
    legend: { type: Boolean, default: !1 },
    disabled: { type: Boolean }
  },
  setup(l) {
    const e = l, o = r(() => e.legend ? "legend" : "label");
    return (s, y) => (t(), i(d(o.value), {
      class: c(["stash-label tw-block tw-truncate tw-text-sm tw-font-medium tw-leading-6", {
        "tw-animate-shake": e.hasError,
        "stash-label--disabled tw-text-ice-700": e.disabled,
        "tw-text-ice-900": !e.disabled
      }]),
      for: e.for,
      "data-test": "stash-label"
    }, {
      default: p(() => [
        f(s.$slots, "default"),
        e.isRequired ? (t(), a("span", h, " * ")) : e.showOptional ? (t(), a("span", _, " (" + m(w(b)("ll.optional")) + ")", 1)) : u("", !0)
      ]),
      _: 3
    }, 8, ["class", "for"]));
  }
});
export {
  x as _
};
//# sourceMappingURL=Label.vue_vue_type_script_setup_true_lang-DPnNUfc6.js.map
